import React from 'react';
import { InterceptedIntel } from '@/lib/api/threatFeedsTypes';

interface InterceptedIntelTableProps {
    data?: InterceptedIntel[];
    isLoading?: boolean;
}

const InterceptedIntelTable: React.FC<InterceptedIntelTableProps> = ({ data = [], isLoading }) => {
    return (
        <div className="bg-[#0A0B0E] border border-[#1A1D24] rounded-xl p-5 shadow-lg flex flex-col h-full font-mono relative overflow-hidden">

            {/* --- EXACT FIGMA NEON-LINE GRAPHIC --- */}
            {/* A glowing, fading horizontal accent line perfectly matching the cyber aesthetic */}
            <div className="absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r from-[#50A970] via-[#50A970]/50 to-transparent shadow-[0_0_12px_rgba(80,169,112,0.8)]"></div>

            <div className="mb-6 mt-1">
                <h2 className="text-[13px] font-bold tracking-wide text-white">Intercepted Intel</h2>
                <p className="text-[10px] text-slate-500 uppercase tracking-widest mt-1">Live Feed • Latest Operations</p>
            </div>

            <div className="flex-1 overflow-x-auto">
                <table className="w-full text-left border-collapse">
                    <thead>
                        <tr>
                            <th className="pb-3 text-[10px] text-slate-500 font-bold uppercase tracking-widest border-b border-[#1A1D24] whitespace-nowrap">Time</th>
                            <th className="pb-3 text-[10px] text-slate-500 font-bold uppercase tracking-widest border-b border-[#1A1D24] whitespace-nowrap">Threat Actor</th>
                            <th className="pb-3 text-[10px] text-slate-500 font-bold uppercase tracking-widest border-b border-[#1A1D24] whitespace-nowrap">Target</th>
                            <th className="pb-3 text-[10px] text-slate-500 font-bold uppercase tracking-widest border-b border-[#1A1D24] whitespace-nowrap">Type</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? (
                            // Loading Skeleton Rows
                            [...Array(5)].map((_, i) => (
                                <tr key={i}>
                                    <td className="py-4 border-b border-[#1A1D24]/50"><div className="h-3 w-12 bg-slate-800 rounded animate-pulse"></div></td>
                                    <td className="py-4 border-b border-[#1A1D24]/50"><div className="h-3 w-24 bg-slate-800 rounded animate-pulse"></div></td>
                                    <td className="py-4 border-b border-[#1A1D24]/50"><div className="h-3 w-32 bg-slate-800 rounded animate-pulse"></div></td>
                                    <td className="py-4 border-b border-[#1A1D24]/50"><div className="h-3 w-20 bg-slate-800 rounded animate-pulse"></div></td>
                                </tr>
                            ))
                        ) : data.length === 0 ? (
                            // Empty State
                            <tr>
                                <td colSpan={4} className="py-8 text-center text-xs text-slate-600 border-dashed border border-slate-800 rounded">
                                    No intercepted intelligence available.
                                </td>
                            </tr>
                        ) : (
                            // Live Data Rows
                            data.map((intel, index) => (
                                <tr
                                    key={index}
                                    className="group hover:bg-[#161c2b]/40 transition-colors duration-200"
                                >
                                    <td className="py-3 px-2 border-b border-[#1A1D24]/50 text-xs text-slate-400">
                                        {intel.time}
                                    </td>
                                    <td className="py-3 px-2 border-b border-[#1A1D24]/50 text-xs text-[#50A970] font-bold">
                                        {intel.actor}
                                    </td>
                                    <td className="py-3 px-2 border-b border-[#1A1D24]/50 text-xs text-slate-200">
                                        {intel.target}
                                    </td>
                                    <td className="py-3 px-2 border-b border-[#1A1D24]/50 text-xs text-slate-400">
                                        {intel.type}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default InterceptedIntelTable;